<ion-item class="message-item" lines="none">
  <ion-label>
    <b *ngIf="!!message" class="sb-empty-state" [ngClass]="colorTheme">{{ message | translate }}</b>
    <span *ngIf="!!subMessage" class="item-md">{{ subMessage | translate }}</span>
    <img *ngIf="!!imageSource" [src]="imageSource" alt="" />
  </ion-label>
</ion-item>
